import { OrthodonticsForAllAgesPage } from "~/components/orthodontics-for-all-ages/OrthodonticsForAllAgesPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/orthodontics-for-all-ages")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo(
      "/orthodontics-for-all-ages",
    ),
  component: OrthodonticsForAllAgesPage,
});
